import React from 'react';

export default function SATextInput(props) {
    const register = props?.register;
    return (
        <React.Fragment>
            <div className="form-group"> 
                {props.label &&
                    <label htmlFor={props.htmlFor}>{props.label}
                        {
                            props.isStrong ?
                                <strong className="text-primary">*</strong>
                                : null
                        }
                    </label>}
                <input
                    {...register(props.name, props.requiredObj)}
                    type={props.type}
                    className="form-control"
                    name={props.name} id={props.name}
                    placeholder={props.placeholder}
                    maxLength={props.maxLength} />
                <small id={props.id} className="text-primary">
                    {props?.errMsg}
                </small>
            </div>
        </React.Fragment>
    )
}
